
import { Vue, Component } from "vue-property-decorator";
import { AmplifyEventBus } from "aws-amplify-vue";

import AuthCard from "@/components/auth/AuthCard.vue";
import UiButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroup.vue";

import { NOTIFICATION } from "@/entities/Events";
import Message, { MessageDuration } from '@/data/notificationsMessages';
import { CHECK_YOUR_EMAIL } from "@/data/notificationMessagesTexts";
import { User } from "@/generated/graphql";

@Component({
  components: {
    AuthCard,
    UiButton,
    FormGroup,
  },
})
export default class ConfirmAccount extends Vue {
  loading: boolean = true;

  email: string = "";
  company: string = "";
  emailSent: boolean = false;
  userToBeChecked?: User = undefined;

  async created(): Promise<void> {
    this.email = (this.$route.params.email as string).replace(" ", "+");
    this.company = (this.$route.params.company as string).replace(" ", "+");

    const uri = `${process.env.VUE_APP_LAMBDA}/check-user-confirmed`;
    const { data }: any = await this.axios.post(uri, { data: {
      email: this.email,
    }});
    this.userToBeChecked = data;

    if (this.userToBeChecked?.confirmed) {
      await AmplifyEventBus.$emit("authState", "signIn");
    } else {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(
          "Please, request a confirmation email and confirm your accont.",
          MessageDuration.LONG
        ),
      );
    }
    this.loading = false;
  }

  async submit(): Promise<void> {
    try {
      const uri = `${process.env.VUE_APP_LAMBDA}/resend-cognito-user`;
      await this.axios.post(uri, {data: {
        user: {email: this.email, company: this.company},
        meta: {role: this.userToBeChecked!.role},
      }});

      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(CHECK_YOUR_EMAIL),
      );
    } catch (e) {
      this.$eventBus.emit(
        NOTIFICATION,
        Message.errorMessage(e.message),
      );
    }
  }
}
